// extracted by mini-css-extract-plugin
export default {"container":"UserSettings_container__L8rby","btn":"UserSettings_btn__GnTjf","themePicker":"UserSettings_themePicker__v2pBx","username":"UserSettings_username__rpIv7"};